import { ChangePassApi } from './ChangePassApi'
import { ProfileApi } from './ProfileApi'
import { FooterPostApi } from './FooterPostApi'
import { addFaqsApi } from './FaqApi'
import { addServiceapi } from './Servicepostapi'
import { addJobapi } from './Jobpostapi'
import { ClientPostApi } from './ClientPostApi'
import { ProfPostApi } from './ProfPostApi'
import { ProjectTrackapi } from './ProjectTrackapi'
import { Reviewpostapi } from './Reviewpostapi'
import { Notificationpostapi } from './Notificationpostapi'

const apiCalls={
    ChangePassApi,
    ProfileApi,
    FooterPostApi,
    addFaqsApi,
    addServiceapi,
    addJobapi,
    ClientPostApi,
    ProfPostApi,
    ProjectTrackapi,
    Reviewpostapi,
    Notificationpostapi,
}
export {apiCalls}